import client from "@/api/client"
import { userResponseSchema } from "@/api/schemas/user"

export const getUser = async () => {
  const response = await client.get("/api/v1/auth/userProfile")

  // Handle empty string or falsy responses
  if (!response.data || response.data === "" || (typeof response.data === "string" && response.data.trim() === "")) {
    return null
  }

  const parsed = userResponseSchema.parse(response.data)
  const result = "data" in parsed ? parsed.data : parsed
  return result
}
